<div style="text-align:center;">
	<mat-dialog-content style="text-align:center;">{{ data.message }}</mat-dialog-content>
	<mat-dialog-actions style="text-align:center;">
		<div style="text-align:center;">
		  <button mat-raised-button (click)="cancel()">CANCEL</button>
		</div>
	</mat-dialog-actions>
</div>